module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapnum"
  }, [_c('a', {
    attrs: {
      "id": "c1"
    }
  }), _c('span', {
    staticClass: "underline"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "chaptitle"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("Lui")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('i', [_vm._v("The body is a tree, with five branches;")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('i', [_vm._v("When the mind is unstable, time enters in")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('i', [_vm._v("Firmly determine the Greater Bliss;")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('i', [_vm._v("Ask the Teacher, says Lui, and know!")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('i', [_vm._v("What is the use of meditation at all?")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('i', [_vm._v("One dies bound to pleasure and pain")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('i', [_vm._v("Give up the bondage of desire")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('i', [_vm._v("the hope for keenness of sense;")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('i', [_vm._v("Draw the wings of emptiness")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('i', [_vm._v("close to your sides")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('i', [_vm._v("Lui says, “I am seen in meditation")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('i', [_vm._v("Seated on the seat of inhalexhalation.”")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('b', [_vm._v("The body is a tree, with five branches; "), _c('br'), _vm._v("When the mind is unstable, time enters in")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("The image of the body as a tree is elaborated by the Chinese Zen Buddhist Lanhsi in his "), _c('i', [_vm._v("Treatise on Meditation")]), _vm._v(": “Ordinary people are like trees: putting the manure of greed and lust on the thin soil of folly and delusion, planting seeds of ignorance, transplanting shoots of form, feeling, perception, conditioning, and consciousness, producing buds of active habit-ridden consciousness, growing roots of attachment and stems of flattery and deceit, sprouting leaves of jealousy and envy, creating trees of affliction, causing flowers of infatuation to bloom, forming fruits of greed, aggression, and ignorance.”"), _c('span', {
    attrs: {
      "href": "#/52notes#c1-FN-5",
      "id": "FN5",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("In Lui's verse, the “five branches” of the tree of the body may be taken to stand for the limbs and head; or they may be understood to refer to the “five clusters” of form, feeling, perception, conditioning, and consciousness, which are commonly used in Buddhist literature to represent a mortal being, as also in Lan-hsi's "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("essay. “When the mind is unstable, time enters in” because the body is governed by the mind and is therefore affected, even afflicted, by fluctuations in the mind, which bring the whole being under the sway of time.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Aristotle is reported to have said, “The soul is not within the body; rather the body is within the soul, because the soul is more extensive than the body, and greater in magnitude.”"), _c('span', {
    attrs: {
      "href": "#/52notes#c1-FN-6",
      "id": "FN6",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("6")])]), _vm._v(" Were the term “mind” in the Buddhist sense substituted for Aristotle's “soul,” this statement could have come from India, in explanation of the primary Buddhist emphasis on care and cultivation of mind. The philosophers and physicians of Taoism, which is much like Tantric Buddhism, also regard instability and hyperactivity of the mind to be direct causes of physical unwellness and deterioriation.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('b', [_vm._v("Firmly determine the Greater Bliss; "), _c('br'), _vm._v("Ask the Teacher, says Lui, and know!")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("The Greater Bliss is subtle transport, beyond the ordinary senses of joy and sorrow. Although it is a natural phenomenon, this is nevertheless sporadic in people subject to ordinary social and psychological conditioning. Therefore it is not accessible as a constant resource unless and until it is deliberately stabilized. This is why there is, in the stage of ultimate realization, no contradiction between natural and attained enlightenment.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Ask the Teacher, says Lui, and know.” This simple exhortation contains many meanings. On the surface is the sense of the need for guidance. In practice it is necessary to “ask the teacher” in order to know, because the confused or unenlightened mind cannot guide itself to enlightenment. Underlying this is the sense of what “teacherhood” is all about. It is properly for the sake of enlightening knowledge alone that one goes to a teacher; not for imagined blessings or graces, let alone lesser goals.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The emphasis on knowing highlights the necessity of direct, firsthand personal experience on the way to enlightenment. The aim is not to be rescued, to be saved, to be convinced, to be converted, to be forgiven, to be absolved, to believe, to have faith, but to "), _c('i', [_vm._v("know")]), _vm._v(". It is through this knowledge, this personal experience of the spiritual euphoria of enlightenment, that one can attain salvation, certainty, and serenity.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('b', [_vm._v("What is the use of meditation at all? "), _c('br'), _vm._v("One dies bound to pleasure and pain")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("After Prince Siddhartha gave up his royal inheritance to seek permanent peace of mind, he followed two Hindu yoga teachers. The first one taught him to reach several stages of meditation, in the highest of which there is no longer any pain or pleasure. The second one taught him to reach a series of stages of abstraction, the most refined being described as neither perception nor nonperception.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Siddhartha found that these yogic experiences seemed to last for very long periods of time, in subjective terms. Yet they inevitably dissolved, leaving the seeker back in the world, now with a profound longing and sorrow at the loss of celestial states. Thus it was that Siddhartha came to realize that these practices and experiences were not eternal spirituality itself, but rather temporal methods of cultivating different perspectives. Siddartha's subsequent detachment from all mental states, both ordinary and extraordinary, ultimately led to his liberation.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("This point was later reemphasized in Zen Buddhism, to remedy centuries of devolutionary sectarian cultism dependent upon attachment to limited theories, practices, and altered states of mind. The Tantric adept Lui here expresses the same stage, known in Universalist Buddhism as “abandoning the raft,” or letting go of the means when the end has been realized.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("In the idea that meditation is a means, not an end, is implicitly echoed the principle that to enter into meditation practice in the wrong frame of mind is useless and even harmful. Seeking personal power, or thrilling experiences, or self-deceptive reality-avoidance, or obsessiveness in general, are unsuitable bases for meditation. Lui warns people not to become wrongly attached to meditation; he also reminds people to scrutinize their own motives and actions. Seekers need to ask themselves what they are really thinking of meditating for in the first place.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('b', [_vm._v("Give up the bondage of desire, the hope for keenness of sense; "), _c('br'), _vm._v("Draw the wings of emptiness close to your sides")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Desire is part of our inherited instinctive constitution, as a mechanism of survival and evolution. Desire can also be infiuenced "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("and cultivated beyond survival value by habit and conditioning. Bondage to desire, preoccupation with craving for intense experience, makes the individual and community especially vulnerable to exaggerated selfishness, aggression, heedlessness, and short-sightedness.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("To give up the bondage of desire is to be able to experience and understand desire without compulsiveness, without augmentation of craving. This is a way to be more objective about desire, and therefore less under the control of associated feelings such as hope, fear, elation, and disappointment.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Ironically, perhaps, attempts to control desire may in fact have the reverse effect of magnifying desire in the mind of someone deliberately trying to control it. This is why Buddhists resort to perception of “emptiness” to transcend the bondage of desire without laboring to extinguish desire itself.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("By viewing desire and its objects as conditional, emphemeral phenomena, and viewing repetitious thinking about desire as self-delusion, Buddhists “draw the wings of emptiness close to their sides,” transcending the bondage of desire even in the very midst of desire.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("To those already obsessed with desire and its fulfillment and frustration, this way of managing desire can seem negative or nihilistic. When the mind is already set on its own preoccupations in that way, the felicitous outcome on the “other side” of liberation from obsession is not even thinkable. The Buddhist goal of realizing emptiness is actually a better happiness, as illustated in the ancient "), _c('i', [_vm._v("Dhammapada")]), _vm._v(". Buddha himself presents the pattern of spiritual regeneration following upon mortification or transcendence of the lower self: “Do not indulge in negligence, do not be intimate with attachment to desire. The vigilant one, meditative, gains great happiness.”"), _c('span', {
    attrs: {
      "href": "#/52notes#c1-FN-7",
      "id": "FN7",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('b', [_vm._v("Lui says, “I am seen in meditation, "), _c('br'), _vm._v("Seated on the seat of inhalexhalation.”")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("This verse may seem, at a glance, to contradict the earlier verse questioning the use of meditation. It must be realized, however, that the earlier verse defines the realizations upon which wholesome meditation and lucid vigilance can be practiced.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The term “inhalexhalation” is a coinage intended to imitate the original technical expression, underlining the sense of the breathing as one continuous cycle in two phases. This is considered "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("a useful exercise for concentrating a scattered mind and preparing it to perceive reality more objectively.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("In ancient Buddhism, mindfulness of breathing and mindfulness of impermanence were referred to as two "), _c('i', [_vm._v("amrta-dvara")]), _vm._v(" or “doors of immortality” leading to nirvana, or clearing of the mind. Mindfulness of breathing was considered the better door in the sense that by nature it contains the other door within it.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The Indian meditation master Prajnatara spoke of both application and realization of this practice in these terms, five hundred years before Lui: “Breathing in, I do not dwell on the elements of mind or body; breathing out, I do not get involved in myriad things.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Zen Buddhists of the Far East, whose teachings resemble those of these Vajrayana Siddhacaryas of Bengal, consider Prajnatara (fifth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("C.E")]), _vm._v(".) their twenty-seventh Indian patriarch. Chinese records say he was from “Eastern India,” which would include the area of what had been Magadha when Buddha was born there a thousand years before Prajnatara, and the Bengali Pala dynasty when Lui sang there five or six hundred years later. Buddha's mother-tongue, Magadhi, and Lui's “Old Bengali” language are directly related.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Thus it is possible to see, in more than one dimension, the historical continuity of Buddhism in its first homeland over a period of at least fifteen hundred years, unbroken through what conventional scholarship generally designates Hinayana, Mahayana, and Vajrayana Buddhism.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-703f4c74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06chapter01.vue
// module id = 72
// module chunks = 0